import { Injectable, signal } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export const MOBILE_SIZE = 767;

@Injectable({
  providedIn: 'root',
})
export class WindowSizeService {
  private readonly _windowSize = signal({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  private readonly _windowSizeSubject = new BehaviorSubject<{ width: number; height: number }>(
    this._windowSize(),
  );

  public readonly windowSize = this._windowSize.asReadonly();
  public readonly windowSize$ = this._windowSizeSubject.asObservable();

  public readonly isMobile$ = this._windowSizeSubject
    .asObservable()
    .pipe(map((size) => size.width < MOBILE_SIZE));

  public updateWindowSize(): void {
    this._windowSize.set({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    this._windowSizeSubject.next(this._windowSize());
  }
}
